import { ILocationLoyaltyOptions } from '@ready/dashboardv2api.contracts';

export const cachedLoyalty = {} as ILocationLoyaltyOptions;
